import React from 'react'
import { Box } from '@mui/material'

export const RequiredMark: React.FC = () => (
  <Box component='span' sx={{ color: 'error.main', ml: 0.5 }}>
    *
  </Box>
)
